import { apiUrl } from "../config";

export const FetchData = async (apiMethod: string):Promise<any> => {
    const response = await fetch(apiUrl + apiMethod);

    if (response.ok) {
      return response.json();
    }

    return Promise.reject(response);
}